import { Platform } from 'react-native';

declare global {
  interface Window {
    fbq?: (
      action: string,
      eventName: string,
      params?: Record<string, any>
    ) => void;
  }
}

export const trackMetaPixelPageView = () => {
  if (Platform.OS !== 'web') {
    return;
  }

  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'PageView');
    } catch (error) {
      console.error('Error tracking Meta Pixel PageView:', error);
    }
  }
};

export const trackMetaPixelLead = () => {
  if (Platform.OS !== 'web') {
    return;
  }

  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'Lead');
    } catch (error) {
      console.error('Error tracking Meta Pixel Lead:', error);
    }
  }
};
